export default function updateMenuDropdowns() {
  const isPresent = document.querySelector(".menu");
  if (!isPresent) {
    return;
  }

  const menuItems = document.querySelectorAll(
    "ul.menu > li.menu-item-has-children a"
  );

  menuItems.forEach((menuItem) => {
    // menuItem.addEventListener("mouseover", function () {
    const dropdown = menuItem.nextElementSibling;

    if (dropdown) {
      let viewWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth
      );
      let dropdownMove = 0;

      dropdown.style.marginLeft = null;
      let rect = dropdown.getBoundingClientRect();
      let move = 0;
      if (rect.x + rect.width > viewWidth) {
        move = rect.x + rect.width - viewWidth + 15;
        dropdown.style.marginLeft = -1 * move + "px";
      }
      dropdownMove = move;
    }
  });
  // });
}
